import PropTypes from 'prop-types';
import React, { Component } from 'react';
import GeckoFeatures from 'services/gecko-features';
import GeckoRequest from 'services/gecko-request';
import { GECKO_CONSTS, GeckoCardForm, GeckoToastService } from 'ui';

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      savingAgent: false,
      desktop_notify_active_tab: false,
      desktop_notify_unassigned: false,
      email_notify_unassigned: false,
      mobile_notify_unassigned: false,
      desktop_notify_mine: false,
      email_notify_mine: false,
      mobile_notify_mine: false,
      desktop_notify_other: false,
      email_notify_other: false,
      mobile_notify_other: false,
      email_notify_bot: false,
      mobile_notify_bot: false,
      desktop_notify_bot: false,
      email_notify_team: false,
      mobile_notify_team: false,
      desktop_notify_team: false,
    };
  }

  componentDidMount() {
    const agent = this.props.agent;
    this.setState({
      desktop_notify_active_tab:
        agent.additional.desktop_notify_active_tab || false,
      desktop_notify_unassigned:
        agent.additional.desktop_notify_unassigned || false,
      email_notify_unassigned:
        agent.additional.email_notify_unassigned || false,
      mobile_notify_unassigned:
        agent.additional.mobile_notify_unassigned || false,
      desktop_notify_mine: agent.additional.desktop_notify_mine || false,
      email_notify_mine: agent.additional.email_notify_mine || false,
      mobile_notify_mine: agent.additional.mobile_notify_mine || false,
      desktop_notify_other: agent.additional.desktop_notify_other || false,
      email_notify_other: agent.additional.email_notify_other || false,
      mobile_notify_other: agent.additional.mobile_notify_other || false,
      desktop_notify_bot: agent.additional.desktop_notify_bot || false,
      email_notify_bot: agent.additional.email_notify_bot || false,
      mobile_notify_bot: agent.additional.mobile_notify_bot || false,
      desktop_notify_team: agent.additional.desktop_notify_team || false,
      email_notify_team: agent.additional.email_notify_team || false,
      mobile_notify_team: agent.additional.mobile_notify_team || false,
    });
  }

  notificationFields = [
    {
      key: 'description',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      width: '100',
      render: () => {
        return (
          <>
            <h2>
              These notifications will trigger when a new message comes into
              Gecko Chat
            </h2>
            <h2>
              Note: Chrome alerts will persist after you log out of Gecko Chat,
              so please only turn Chrome alerts on if you are not using a shared
              device
            </h2>
          </>
        );
      },
    },
    {
      key: 'unassigned_label',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      width: '100',
      render: () => {
        return (
          <h1>
            Any new messages for <b>unassigned conversations</b>:
          </h1>
        );
      },
    },
    {
      label: 'Chrome & Sound:',
      key: 'desktop_notify_unassigned',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Email:',
      key: 'email_notify_unassigned',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Mobile:',
      key: 'mobile_notify_unassigned',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      key: 'assigned_to_you_label',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      width: '100',
      render: () => {
        return (
          <h1>
            Any new messages in <b>conversations assigned to you</b>:
          </h1>
        );
      },
    },
    {
      label: 'Chrome & Sound:',
      key: 'desktop_notify_mine',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Email:',
      key: 'email_notify_mine',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Mobile:',
      key: 'mobile_notify_mine',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      key: 'assigned_to_team_label',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      width: '100',
      render: () => {
        return (
          <h1>
            Any new messages in{' '}
            <b>conversations assigned to any of your teams</b>:
          </h1>
        );
      },
    },
    {
      label: 'Chrome & Sound:',
      key: 'desktop_notify_team',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Email:',
      key: 'email_notify_team',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Mobile:',
      key: 'mobile_notify_team',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      key: 'assigned_to_others_label',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      width: '100',
      render: () => {
        return (
          <h1>
            Any new messages in <b>conversations assigned to other users</b>:
          </h1>
        );
      },
    },
    {
      label: 'Chrome & Sound:',
      key: 'desktop_notify_other',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Email:',
      key: 'email_notify_other',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Mobile:',
      key: 'mobile_notify_other',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      disabledWhen: () => this.state.savingAgent,
    },
    {
      key: 'assigned_to_bot_label',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      width: '100',
      hideWhen: () => !GeckoFeatures.can('chat-bot'),
      render: () => {
        return (
          <h1>
            Any new messages in <b>conversations assigned to bots</b>:
          </h1>
        );
      },
    },
    {
      label: 'Chrome & Sound:',
      key: 'desktop_notify_bot',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      hideWhen: () => !GeckoFeatures.can('chat-bot'),
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Email:',
      key: 'email_notify_bot',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      hideWhen: () => !GeckoFeatures.can('chat-bot'),
      disabledWhen: () => this.state.savingAgent,
    },
    {
      label: 'Mobile:',
      key: 'mobile_notify_bot',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '30%',
      hideWhen: () => !GeckoFeatures.can('chat-bot'),
      disabledWhen: () => this.state.savingAgent,
    },
    {
      key: 'active_tab_label',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      width: '100',
      hideWhen: () =>
        !this.state.desktop_notify_unassigned &&
        !this.state.desktop_notify_team &&
        !this.state.desktop_notify_mine &&
        !this.state.desktop_notify_other &&
        !this.state.desktop_notify_bot,
      render: () => {
        return (
          <div>
            <hr />
            <span>
              By default, chrome alerts will not show if you are currently using
              the chat system. Enable this option to trigger Chrome alerts even
              when the Chat tab is active.
            </span>
          </div>
        );
      },
    },
    {
      label: 'Persistent Chrome Alerts:',
      key: 'desktop_notify_active_tab',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '50%',
      hideWhen: () =>
        !this.state.desktop_notify_unassigned &&
        !this.state.desktop_notify_mine &&
        !this.state.desktop_notify_team &&
        !this.state.desktop_notify_other &&
        !this.state.desktop_notify_bot,
      disabledWhen: () => this.state.savingAgent,
    },
  ];

  handleInputChange(key, value) {
    this.setState({ savingAgent: true });
    const agent = this.props.agent;
    const newPrefs = this.state;
    newPrefs[key] = value;
    this.setState({
      desktop_notify_active_tab: newPrefs.desktop_notify_active_tab || false,
      desktop_notify_unassigned: newPrefs.desktop_notify_unassigned || false,
      email_notify_unassigned: newPrefs.email_notify_unassigned || false,
      mobile_notify_unassigned: newPrefs.mobile_notify_unassigned || false,
      desktop_notify_mine: newPrefs.desktop_notify_mine || false,
      email_notify_mine: newPrefs.email_notify_mine || false,
      mobile_notify_mine: newPrefs.mobile_notify_mine || false,
      desktop_notify_other: newPrefs.desktop_notify_other || false,
      email_notify_other: newPrefs.email_notify_other || false,
      mobile_notify_other: newPrefs.mobile_notify_other || false,
      desktop_notify_bot: newPrefs.desktop_notify_bot || false,
      email_notify_bot: newPrefs.email_notify_bot || false,
      mobile_notify_bot: newPrefs.mobile_notify_bot || false,
      desktop_notify_team: newPrefs.desktop_notify_team || false,
      email_notify_team: newPrefs.email_notify_team || false,
      mobile_notify_team: newPrefs.mobile_notify_team || false,
    });
    delete newPrefs.savingAgent;
    Object.assign(agent.additional, newPrefs);
    delete agent.full_name;
    GeckoRequest.post(`/models/agents/${this.props.agent.id}`, agent)
      .then((res) => {
        new GeckoToastService().success('Preferences updated');
        this.setState({ savingAgent: false });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  render() {
    return (
      <GeckoCardForm
        name="Notification Preferences"
        fields={this.notificationFields}
        values={this.state}
        headerBtns={[]}
        footerBtns={[]}
        handler={this.handleInputChange.bind(this)}
      ></GeckoCardForm>
    );
  }
}

Notifications.defaultProps = {};

Notifications.propTypes = {
  agent: PropTypes.object.isRequired,
};

export default Notifications;
